import React, { Component } from 'react';
import Graph from './components/graph';
import QuarterSelector from './components/quarter-tab';
import gaPush from '../../../../../../globs/utils/google-analytics';


class TrendAnalysis extends Component {
  constructor(props) {
    super(props);
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentQuarter = Math.ceil(currentMonth / 3);
    this.state = {
      currentQuarter,
      selectedQuarter: currentQuarter,
    };
  }

  getCurrentQuarterOrders = (orders) => {
    const retObj = {
      [(this.state.selectedQuarter * 3) - 2]: {
        is_confirmed: false,
        estimated_bags_total: 0,
      },
      [(this.state.selectedQuarter * 3) - 1]: {
        is_confirmed: false,
        estimated_bags_total: 0,
      },
      [this.state.selectedQuarter * 3]: {
        is_confirmed: false,
        estimated_bags_total: 0,
      },
    };
    Object.keys(orders).sort().forEach((orderKey) => {
      if (this.state.selectedQuarter === Math.ceil(orderKey.slice(5, 7) / 3)) {
        retObj[parseInt(orderKey.slice(5, 7), 10)] = orders[orderKey];
      }
    });
    return retObj;
  }

  getHighestBagsLiftedCount = (orders) => {
    // console.log('order=====>', orders);
    let highestBagsCount = 0;
    Object.keys(orders).forEach((orderKey) => {
      const orderBagsCount = orders[orderKey].total_quantity ?
        orders[orderKey].total_quantity : orders[orderKey].total_quantity;
      if (orderBagsCount > highestBagsCount) {
        highestBagsCount = orderBagsCount;
      }
    });
    return highestBagsCount;
  }

  handleQuarterSelection = (quarter) => {
    gaPush('event', {
      category: 'TonageReport',
      action: 'ChartQuarterClicked',
      label: `${quarter}`,
    });
    this.setState({
      selectedQuarter: quarter,
    });
  }

  render() {
    const { props, state } = this;
    const { orders } = props;
    // console.log(props, 'props;;;;;');
    const currQuarterOrders = this.getCurrentQuarterOrders(orders);
    const highestBagsCount = this.getHighestBagsLiftedCount(currQuarterOrders);
    return (
      <div className="lr-trend-analysis">
        {/* <div className="lr-performance-heading">
      <FormattedMessage id="MyPerformance.TrendAnalysisLabel" /></div> */}
        <div className="lr-trend-analysis_graph">
          <QuarterSelector
            handleQuarterSelection={this.handleQuarterSelection}
            selectedQuarter={state.selectedQuarter}
            currentQuarter={state.currentQuarter}
            enabledQuarters={props.enabledQuarters}
          />
          <Graph
            orders={currQuarterOrders}
            highestBagsCount={highestBagsCount}
            user={props.user}
          />
        </div>
      </div>
    );
  }
}

export default TrendAnalysis;
